<style  scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style scoped="scoped">
	.mobileLogin {
		color: #333333;
		font-family:"SourceHanSansCN-Regular";
		font-size: 12px;
	}
	.mobileLogin .login_title{
  margin: 20px 0px;
  font-size:22px;
  letter-spacing: 2px;
  text-align: center;
  font-family:MicrosoftYaHei;
  font-weight:600;
  color:rgba(51,51,51,1);
}
.mobileLogin .login-content .login_form_wrapper{
  width: 90%;
  margin: 0 auto;
  text-align: right;
}

.mobileLogin .login-content .login_form_wrapper .login_btn {
  color: #FFFEFE;
  width: 100%;
  height: 40px;
  background: rgba(16, 142, 233, 1);
  border-radius: 6px;
  margin-bottom: 20px;
}
.mobileLogin .login-content .login_form_wrapper .forgetpassword{
  text-align: right;
  color: #999999;
  margin-bottom: 20px;
}
.mobileLogin .login-content .login_form_wrapper .forgetpassword>a{
  color: #999999;
  text-decoration: none;
  cursor: pointer;
}
.mobileLogin .login-content .login_form_wrapper  .register{
	width: 100%;
	margin-bottom: 20px;
  display: inline-block;
  text-align: right;
}
.mobileLogin .login-content .login_form_wrapper  .register>a{
  color: #999999;
  text-decoration: none;
  cursor: pointer;
}
</style>
<style type="text/css">
  .mobileLogin .login-content  .el-form-item.is-success .el-input__inner,
  .mobileLogin .login-content  .el-form-item.is-success .el-textarea__inner{
    border-color:#D6D6D6;
  }
  .mobileLogin .login-content  .el-form-item.is-success .el-input__inner:focus,
  .mobileLogin .login-content  .el-form-item.is-success .el-textarea__inner:focus{
    background:rgba(255,255,255,1);
    border:1px solid rgba(16,142,233,1);
    border-radius:6px;
  }
  .mobileLogin .btn_color{
    color:#108EE9!important;
    font-weight:400;
	}
	.mobileLogin .el-form-item{
		margin-bottom:20px;
	}
  .mobileLogin .el-input--prefix .el-input__inner{
    padding-left: 35px;
  }
  .mobileLogin .login_form_wrapper .forgetpassword .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #666666;
    vertical-align: bottom;
  }
  .mobileLogin .login_form_wrapper .forgetpassword .el-checkbox__label{
    color: #666666;
    vertical-align: bottom;
  }

  .mobileLogin .login_form_wrapper .el-checkbox__input.is-checked .el-checkbox__inner,
  .mobileLogin .login_form_wrapper .el-checkbox__inner:hover,
  .mobileLogin .login_form_wrapper .el-checkbox__inner:focus,
  .mobileLogin .login_form_wrapper .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: #666666;
  }
  .mobileLogin .login_form_wrapper .el-checkbox__input.is-checked .el-checkbox__inner::after{
    color: #666666;
    border-color: #666666;
  }
  .mobileLogin .login_form_wrapper .el-checkbox__inner{
    border-color: #666666;
  }
</style>
<template>
  <div class="mobileLogin">
		<header class="mobilehead">
			<el-row>
				<el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
				<el-col :span="16"><div class="tlc">欢迎登陆</div></el-col>
				<el-col :span="4"><div></div></el-col>
			</el-row>
		</header>

    <div class="login-content">
      <div class="login_title">欢迎登录</div>
      <div class="login_form_wrapper">
        <el-form :model="loginForm"  ref="loginForm" :rules="rules"  class="loginform" >
          <el-form-item label="" prop="username">
            <el-input  v-model.trim="loginForm.username" autocomplete="off" max="20" @blur="blurPassword" @keyup.enter.native="submitForm('loginForm')" clearable>
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>

          <el-form-item label=""  prop="password">
            <el-input type="password" v-model.trim="loginForm.password" autocomplete="off" max="100" @keyup.enter.native="submitForm('loginForm')" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="forgetpassword"><el-checkbox v-model="checked" class="fl">记住密码</el-checkbox> <a @click="forgetPwd()" class="btn_color">忘记密码</a></div>
         <el-button class="login_btn" @click="submitForm('loginForm')" @keyup.enter.native="submitForm('loginForm')" :loading="loadingLogin"> 立即登录</el-button>
         <div class="register"> <a @click="register()" class="btn_color">立即注册</a></div>
        </div>
    </div>

    <!-- <div id="toTop" class="toTop" v-show="isShow" @click="toTop()"> -->
    </div>
    <!-- <footer>
      <div class="footer_con">
        <div class="footer_con_two">Copyright ©1996-2019 All Rights Reserved<br/>三端科技&nbsp;版权所有</div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import detailService from '@/service/front/detailService'
import commonService from '@/service/commonService'
export default {
  name: 'mobileLogin',
  data: function () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      checked: true,
      loadingLogin: false,
      rules: {
        username: [
          { required: true, message: '请输入登录手机号码', trigger: 'blur' },
          { validator: this.$rules.phoneNumber, trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入正确密码', trigger: 'blur' }]
      }
    }
  },

  async mounted () {
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    blurPassword () {
      if (!this.loginForm.password) {
        this.loginForm.password = this.$cookie.get('user' + this.loginForm.username)
      }
    },
    async fetchUserInfo () {
      let data = await detailService.fetchDetail()
      return data
    },
    submitForm (formName) {
      this.loadingLogin = true
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.$cookie.set('token', this.SysConstant.basicAuth)
          try {
            let data = await commonService.login(this.loginForm)
            if (data) {
              this.$cookie.set(
                'token',
                data.token_type + ' ' + data.access_token,
                {
                  expires: '3600s'
                }
              )
              let userInfo = await this.fetchUserInfo()
              this.$store.commit('clearUserInfo')
              this.$store.commit('setUserInfo', userInfo)
              this.$router.push({name: 'mobiledetail'})
              if (this.checked) {
                // 记住密码
                this.$cookie.set(
                  'user' + this.loginForm.username,
                  this.loginForm.password,
                  { expires: '3D' }
                )
              } else {
                // 清空记住密码
                this.$cookie.remove('user' + this.loginForm.username)
              }
            }
          } catch (e) {
            this.$message.error({
              message: e && e.msg,
              customClass: 'errmsg'
            })
          }
        } else {
          this.$message.error({
            message: '请输入正确手机号、密码',
            customClass: 'errmsg'
          })
          return false
        }
      })
      this.loadingLogin = false
    },
    forgetPwd () {
      this.$router.push({name: 'mobileForgetpsw'})
    },
    register () {
      this.$router.push({name: 'mobileRegister'})
    },
    // 屏幕滚动
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let i = 0
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobilelogin/index.vue